/* Enhances Shrine's existing cart; cart mutations remain owned by the theme. */
(() => {
  const sessionDeadlines = new Map();
  if (!customElements.get('pf-offer-timer')) {
    customElements.define('pf-offer-timer', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.interval);
        this.startObserver?.disconnect();
        this.sessionMode = this.dataset.mode === 'session';
        this.storageKey = `pf-cart-timer:${this.dataset.timerKey || 'cart'}:${this.dataset.duration || 600}`;
        // Fixed promotions require a timezone; relative cart timers start on opening.
        const value = this.dataset.deadline || '';
        this.deadline = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
        this.tick = () => {
          const seconds = Math.ceil((this.deadline - Date.now()) / 1000);
          const output = this.querySelector('[data-pf-time]');
          if (!Number.isFinite(seconds) || (!this.sessionMode && seconds <= 0) || !output) {
            this.hidden = true;
            clearInterval(this.interval);
            return;
          }
          const remaining = Math.max(0, seconds);
          const hours = Math.floor(remaining / 3600);
          const minutes = Math.floor((remaining % 3600) / 60);
          const pad = n => String(n).padStart(2, '0');
          output.textContent = `${hours ? `${pad(hours)}:` : ''}${pad(minutes)}:${pad(remaining % 60)}`;
          this.hidden = false;
          if (remaining === 0) clearInterval(this.interval);
        };
        const start = () => {
          if (this.sessionMode) {
            let saved = sessionDeadlines.get(this.storageKey);
            try { saved = Number(sessionStorage.getItem(this.storageKey)) || saved; } catch (_) { /* Storage may be blocked. */ }
            const duration = Number(this.dataset.duration);
            this.deadline = Number.isFinite(saved) ? saved : Date.now() + (Number.isFinite(duration) && duration > 0 ? duration : 600) * 1000;
            sessionDeadlines.set(this.storageKey, this.deadline);
            try { sessionStorage.setItem(this.storageKey, String(this.deadline)); } catch (_) { /* Keep the in-memory deadline. */ }
          }
          this.tick();
          if (!this.hidden && this.deadline > Date.now()) this.interval = setInterval(this.tick, 1000);
        };
        const cartDrawer = this.closest('cart-drawer');
        if (this.sessionMode && cartDrawer && (!cartDrawer.classList.contains('active') || cartDrawer.classList.contains('is-empty'))) {
          this.startObserver = new MutationObserver(() => {
            if (cartDrawer.classList.contains('active') && !cartDrawer.classList.contains('is-empty')) {
              this.startObserver.disconnect();
              start();
            }
          });
          this.startObserver.observe(cartDrawer, {attributes:true, attributeFilter:['class']});
        } else start();
      }
      disconnectedCallback() { clearInterval(this.interval); this.startObserver?.disconnect(); }
    });
  }
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  const syncToggle = upsell => {
    const toggle = upsell.querySelector('[role="switch"]');
    if (toggle) toggle.setAttribute('aria-checked', String(upsell.dataset.selected === 'true'));
  };
  const syncAll = () => drawer.querySelectorAll('cart-drawer-upsell[data-toggle="true"]').forEach(syncToggle);
  syncAll();
  new MutationObserver(records => {
    if (records.some(record => record.type === 'childList')) syncAll();
    records.filter(record => record.type === 'attributes').forEach(record => syncToggle(record.target));
  }).observe(drawer, {childList:true, subtree:true, attributes:true, attributeFilter:['data-selected']});
})();
